import PostFeedbackRequestModelBase from '../_generated/modelBases/post-feedback-request-model-base';

export default class PostFeedbackRequestModel extends PostFeedbackRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
